import { render, staticRenderFns } from "./AccordianComponent.vue?vue&type=template&id=0bab8bf0&scoped=true"
import script from "./AccordianComponent.vue?vue&type=script&lang=js"
export * from "./AccordianComponent.vue?vue&type=script&lang=js"
import style0 from "./AccordianComponent.vue?vue&type=style&index=0&id=0bab8bf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bab8bf0",
  null
  
)

export default component.exports